module.exports = __webpack_public_path__ + "img/icon-onestop-flow.db8588f0.png";